import { signUpSlice } from './signUp/slice';
import { workspaceSlice } from './workspace/slice';
import { forgetPasswordSlice } from './forgetPassword/slice';
import { authSlice } from './auth/slice';
import { generalSlice } from './general/slice';
import { examSlice } from './exam/slice';

export const reducer = {
  auth: authSlice.reducer,
  general: generalSlice.reducer,
  exam: examSlice.reducer,
  signUp: signUpSlice.reducer,
  workspace: workspaceSlice.reducer,
  forgetPassword: forgetPasswordSlice.reducer,
};